<template>

    <div class="grow">
        <!-- Change the height attribute to adjust the chart height -->
        <LineChartLinear :data="chartData" :width="width" :height="height" v-if="linear"/>
        <LineChart :data="chartData" :width="width" :height="height" v-else/>
    </div>

</template>

<script>
import { ref } from 'vue'
import LineChart from '../charts/LineChart08.vue'
import LineChartLinear from '../charts/LineChartLinear.vue'

// Import utilities
import { hexToRGB, tailwindConfig } from '../utils/Utils'

export default {
    name: "Ticker",
    components: {
        LineChart,
        LineChartLinear
    },
    props: {
        data: Array,
        labels: Array,
        growing: Boolean,
        tailwindColor: String,
        width: {
            type: Number,
            default: 286,
        },
        height: {
            type: Number,
            default: 98,
        },
        linear: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        let backgroundColor, borderColor, pointBackgroundColor
        if (props.growing) {
            backgroundColor = `rgba(${hexToRGB(tailwindConfig().theme.colors.emerald[500])}, 0.08)`
            borderColor = tailwindConfig().theme.colors.emerald[500]
            pointBackgroundColor = tailwindConfig().theme.colors.emerald[500]
        } else {
            backgroundColor = `rgba(${hexToRGB(tailwindConfig().theme.colors.rose[500])}, 0.08)`
            borderColor = tailwindConfig().theme.colors.rose[500]
            pointBackgroundColor = tailwindConfig().theme.colors.rose[500]
        }

        if (props.tailwindColor) {
            backgroundColor = `rgba(${hexToRGB(tailwindConfig().theme.colors[props.tailwindColor]['DEFAULT'])}, 0.08)`
            borderColor = tailwindConfig().theme.colors[props.tailwindColor]['DEFAULT']
            pointBackgroundColor = tailwindConfig().theme.colors[props.tailwindColor]['DEFAULT']
        }

        const chartData = ref({
            labels: props.labels,
            datasets: [
                {
                    data: props.data,
                    fill: true,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderWidth: 2,
                    tension: 0,
                    pointRadius: 0,
                    pointHoverRadius: 3,
                    pointBackgroundColor: pointBackgroundColor,
                    clip: 20,
                },
            ],
        })

        return {
            chartData,
        }
    },
    created() {

    }
}
</script>

<style scoped>

</style>
